import React, { useState } from "react";
import { Collapse } from "react-collapse";
import styles from "./profileComponent.css";
import classNames from "classnames";

interface DropdownSectionProps extends React.PropsWithChildren<{}> {
  title: string;
}

export const DropdownSection = ({ children, title }: DropdownSectionProps) => {
  const [contentOpened, setContentOpened] = useState<boolean>(false);
  return (
    <div className={styles["dropdown-wrapper"]}>
      <div className={styles["dropdown-header"]} onClick={() => setContentOpened(!contentOpened)}>
        {title}
        <i className={classNames("icon-arrow", contentOpened ? styles.active : "")} />
      </div>
      <Collapse
        isOpened={contentOpened}
        theme={{ collapse: styles["dropdown-collapse"], content: styles["dropdown-content"] }}
      >
        {children}
      </Collapse>
    </div>
  );
};
